import Keycloak from 'keycloak-js'
import getEnvConfig from 'utils/getEnvConfig'
const keycloak = (): Keycloak.KeycloakInstance => {
    const envConfig = getEnvConfig()
    return new Keycloak({
        url: envConfig.KeycloakURL,
        realm: envConfig.KeycloakRealm,
        clientId: envConfig.KeycloakClientIDOP,
    })
}

export default keycloak
